import { useEffect } from "react"

const LAUNCH_DARKLY_ID_COOKIE = "bp_ld_id"

export const useSetLaunchDarklyId = (): void => {
  useEffect(() => {
    // If the cookie is already set, don't make the request
    // use of sessionStorage over retrieving the cookie directly
    // as timing impacts cookie retrieval
    const launchDarklyId = sessionStorage.getItem(LAUNCH_DARKLY_ID_COOKIE)
    if (launchDarklyId) {
      return
    }
    try {
      const requestOptions: RequestInit = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }
      fetch(
        `${process.env.NEXT_PUBLIC_BEAUTYPIE_ANALYTICS_URI}/launch-darkly`,
        requestOptions
      )
      // update sessionStorage to prevent multiple requests
      sessionStorage.setItem(LAUNCH_DARKLY_ID_COOKIE, "set")
    } catch (e) {
      console.error((e as Error).message)
    }
  }, [])
}
